export default __webpack_public_path__ + "static/crossweb-ff30458675beb74b591eeba3eef3bcc8.jpg";